import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { PublicLeadForm } from "@/components/PublicLeadForm";
import { CopyIframeButton } from "@/components/LeadEditDialog";
import { api, errMsg } from "@/lib/api";

export default function LeadFormPage() {
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const embedded = window.self !== window.top;
  const submit = async (f) => {
    setBusy(true);
    try {
      const r = await api.post("/public/leads", { ...f, source: "Lead Gen Form" });
      setDone(r.data.leadNumber);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-white text-zinc-900 font-[Quicksand,sans-serif]">
      <div className="w-full max-w-[720px] mx-auto px-5 py-6 sm:py-10">
        {!embedded && <img src="/brand/gn-logo.png" alt="Gamerz Nation" className="h-14 w-auto mb-8" />}
        {done ? (
          <div className="text-center py-16" data-testid="lead-form-success">
            <CheckCircle2 className="h-12 w-12 text-[#1c4436] mx-auto" />
            <h2 className="text-2xl font-semibold mt-4">Thanks, we've got your PC build request</h2>
            <p className="text-[17px] text-zinc-600 mt-2">Reference <span className="font-semibold" data-testid="lead-form-number">{done}</span>. Our build consultant will reach out on your preferred channel within 24 hours.</p>
          </div>
        ) : <PublicLeadForm onSubmit={submit} busy={busy} />}
        {!embedded && !done && <div className="mt-8 pt-4 border-t flex justify-center"><CopyIframeButton variant="ghost" /></div>}
      </div>
    </div>
  );
}
